import React, { useMemo } from "react";

import { SOP_TABS } from "../../../constants";

import TableActionsIconsGroup from "../../../stories/Components/Table/TableActionsIconsGroup";
import BackButton from "../../../stories/Components/WidgetEditorView/Header/BackButton";
import WidgetContainer from "../../../stories/Components/Widget/WidgetContainer";
import FilesTable from "../../../stories/Components/FilesTable/FilesTable";
import InlineInput from "../../../stories/Components/Input/InlineInput";
import ImagesAndVideosWidget from "../../../stories/Components/MediaWidget/ImagesAndVideosWidget";
import SiteHeader from "../../../stories/Components/SiteHeader/SiteHeader";

import SopActivity from "../../../components/Sop/Activity";
import SopDetailsView from "../../../components/Sop/DetailsView";

import useDetailsVersionData from "./useDetailsVersionData";

const SopDetailsVersion = () => {
  const {
    loading,
    sopId,
    sop,
    showActivity,
    setShowActivity,
    handleNavigationBack,
    version,
    activeTab,
    setActiveTab,
    catOptions,
    associatedFiles,
  } = useDetailsVersionData();

  const tabs = useMemo(
    () => [
      {
        id: SOP_TABS.DETAILS_ID,
        title: SOP_TABS.DETAILS_TITLE,
        content: (
          <SopDetailsView
            loading={loading}
            sop={sop}
            stepData={sop?.steps}
            categoryOptionsList={catOptions}
          />
        ),
      },
      {
        id: SOP_TABS.MEDIA_ID,
        title: SOP_TABS.MEDIA_TITLE,
        content: (
          <ImagesAndVideosWidget
            border={false}
            resource={sop}
            disableEditing
            hasWritePermission={false}
            hasDeletePermission={false}
            hasEditPermission={false}
          />
        ),
      },
      {
        id: SOP_TABS.FILES_ID,
        title: SOP_TABS.FILES_TITLE,
        content: (
          <FilesTable
            files={associatedFiles}
            resourceName="Sop"
            association={`Sop/${sopId}`}
            hasWritePermission={false}
            hasDeletePermission={false}
            hasEditPermission={false}
          />
        ),
      },
    ],
    [loading, sop, catOptions, associatedFiles, sopId]
  );

  return (
    <>
      <SiteHeader
        title={
          <div className="flex items-center">
            <InlineInput
              width="w-full"
              size="custom4xl"
              value={`${sop?.name}: Version ${version}`}
              loading={loading}
              disabled
              fontWeight="bold"
              color="gray-650"
              hidePencil
              isHeaderTitle
            />
          </div>
        }
        hideDropdownContainer
      />

      <BackButton onBackPressed={handleNavigationBack} />

      {showActivity ? (
        <SopActivity sopId={sopId} />
      ) : (
        <WidgetContainer
          className="p-4 border-gray-200 shadow-lg border rounded-md"
          style={{ minWidth: "903px" }}
          tabs={tabs}
          loading={loading}
          activeTab={activeTab}
          onTabClick={(t) => setActiveTab(t)}
          actionsButtons={
            <TableActionsIconsGroup
              style={{ height: "100%" }}
              onActivityClicked={() => setShowActivity(true)}
            />
          }
        />
      )}
    </>
  );
};

export default SopDetailsVersion;
